module.exports = __webpack_public_path__ + "img/trace_code_result.5c0db8df.png";